var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"card--shadow"},[_c('patient-list',{attrs:{"patients":_vm.patients}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }